export type SentryLogOptions = {
  level?: 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug';
  loggerId?: string;
  sessionId?: string;
  userId?: string;
  brand?: string;
  extra?: Record<string, unknown>;
};

export type ReplayIntegration = {
  stop: () => void;
};

export const isReplayIntegration = (integration: unknown): integration is ReplayIntegration =>
  typeof integration === 'object' &&
  integration !== null &&
  'stop' in integration &&
  typeof (integration as { stop?: unknown }).stop === 'function';
